import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import commonStyles from 'LegacyWeployDesignLanguage/icons/styles';
import MUIIconButton from '@material-ui/core/IconButton';


const useStyles = makeStyles({
  ...commonStyles().icon,
});

const CloseButton = ({ onClick }) => {
  const classes = useStyles();

  return (
    <MUIIconButton onClick={onClick}>
      <CloseIcon classes={{ root: classes.root }} className={classes.icon} />
    </MUIIconButton>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CloseButton;
